const SDK_VERSION = '8.6.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
